import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BaseRequestOptions } from '@angular/http';
import { RouterModule } from '@angular/router';
import { CollapseDirective, ModalModule } from 'ngx-bootstrap';
import { Ng2SmartTableModule } from 'ngx-smart-table';
import { UiSwitchModule } from 'ngx-ui-switch';
import { CookieService } from 'angular2-cookie/services/cookies.service';

import { ContentHeaders } from './common/headers';
import { AuthGuard } from './common/auth.guard';
import { AuthenticationService } from './services/authentication.service';
import { UserService } from './services/user.service';
import { DeviceService } from './services/device.service';
import { SynologyService } from './services/synology.service';
import { PrivilegesService } from './services/privileges.service';

import { AppComponent } from './components/app/app.component';
import { HomeComponent } from './components/home/home.component';
import { UserListComponent } from './components/user-list/user-list.component';
import { UserDetailComponent } from './components/user-detail/user-detail.component';
import { GroupListComponent } from './components/group-list/group-list.component';
import { GroupDetailComponent } from './components/group-detail/group-detail.component';
import { QuizRunListComponent } from './components/quiz-run-list/quiz-run-list.component';
import { QuestionGroupListComponent } from './components/questiongroup-list/questiongroup-list.component';
import { QuestionGroupDetailComponent } from './components/questiongroup-detail/questiongroup-detail.component';
import { QuestionListComponent } from './components/question-list/question-list.component';
import { QuestionDetailComponent } from './components/question-detail/question-detail.component';
import { VoteLocationListComponent } from './components/votelocation-list/votelocation-list.component';
import { VoteLocationDetailComponent } from './components/votelocation-detail/vote-location-detail.component';
import { DevicesComponent } from './components/devices/devices.component';
import { DeviceInfoComponent } from './components/device-info/device-info.component';
import { DevicesHistoryComponent } from './components/devices-history/devices-history.component';
import { DeviceHistoryComponent } from './components/device-history/device-history.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ConfirmResetPasswordComponent } from './components/confirm-reset-password/confirm-reset-password.component';
import { HeaderComponent } from './components/shared/header/header.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { LoaderComponent } from './components/shared/loader/loader.component';
import { ImprintComponent } from './components/imprint/imprint.component';
import { PrivacyComponent } from './components/privacy/privacy.component';
import { StoreModule } from '@ngrx/store';
import { reducers, metaReducers } from './reducers';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [
    CollapseDirective,
    AppComponent,
    HomeComponent,
    DevicesComponent,
    DeviceInfoComponent,
    DevicesHistoryComponent,
    DeviceHistoryComponent,
    UserListComponent,
    UserDetailComponent,
    GroupListComponent,
    GroupDetailComponent,
    QuizRunListComponent,
    QuestionGroupListComponent,
    QuestionGroupDetailComponent,
    QuestionListComponent,
    QuestionDetailComponent,
    VoteLocationListComponent,
    VoteLocationDetailComponent,
    LoginComponent,
    LogoutComponent,
    ChangePasswordComponent,
    ResetPasswordComponent,
    ConfirmResetPasswordComponent,
    HeaderComponent,
    FooterComponent,
    PrivacyComponent,
    ImprintComponent,
    LoaderComponent
  ],
  imports: [
      RouterModule.forRoot([
       { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'home', component: HomeComponent, canActivate: [AuthGuard]},
            { path: 'users', component: UserListComponent, canActivate: [AuthGuard]},
            { path: 'user/detail/:userId', component: UserDetailComponent, canActivate: [AuthGuard]},
            { path: 'groups', component: GroupListComponent, canActivate: [AuthGuard]},
            { path: 'group/detail/:groupId', component: GroupDetailComponent, canActivate: [AuthGuard]},
            { path: 'quizruns', component: QuizRunListComponent, canActivate: [AuthGuard]},
            { path: 'questiongroups', component: QuestionGroupListComponent, canActivate: [AuthGuard]},
            { path: 'questiongroup/detail/:questionGroupId', component: QuestionGroupDetailComponent, canActivate: [AuthGuard]},
            { path: 'votelocations', component: VoteLocationListComponent, canActivate: [AuthGuard]},
            { path: 'voteLocation/detail/:voteLocationId', component: VoteLocationDetailComponent, canActivate: [AuthGuard]},
            { path: 'questions', component: QuestionListComponent, canActivate: [AuthGuard]},
            { path: 'question/detail/:questionId/:questionGroupId', component: QuestionDetailComponent, canActivate: [AuthGuard]},
            { path: 'devices', component: DevicesComponent, canActivate: [AuthGuard]},
            { path: 'devices-history', component: DevicesHistoryComponent, canActivate: [AuthGuard]},
            { path: 'login', component: LoginComponent },
            { path: 'logout', component: LogoutComponent },
            { path: 'changePassword', component: ChangePasswordComponent, canActivate: [AuthGuard] },
            { path: 'resetPassword', component: ResetPasswordComponent },
            { path: 'resetPassword/confirm/:token', component: ConfirmResetPasswordComponent },
            { path: 'privacy', component: PrivacyComponent },
            { path: 'imprint', component: ImprintComponent },
            { path: '**', redirectTo: 'home' }
    ]),
    BrowserModule,
    HttpModule,
    UiSwitchModule,
    Ng2SmartTableModule,
    ModalModule.forRoot(), StoreModule.forRoot(reducers, { metaReducers }), !environment.production ? StoreDevtoolsModule.instrument() : []
  ],
  providers: [
        AuthGuard,
        AuthenticationService,
        PrivilegesService,
        UserService,
        CookieService,
        DeviceService,
        SynologyService,
        ContentHeaders,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts